import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

class GroupsForm extends React.Component {

  componentWillMount(){
    const { setGroups } = this.props;
    const storedString = localStorage.paymentsGroups;
    const storedGroups = (storedString && JSON.parse(storedString)) ||
      ['date', 'seller', 'srvc'];
    setGroups(storedGroups);
  }

  setGroup = (index, group) => {
    const { groups, setGroups } = this.props;
    if(!group){
      setGroups(groups.slice(0, index));
    }
    else if(groups.indexOf(group) !== -1){
      // setGroups([
        // ...groups.slice(0, index),
        // ...groups.slice(index + 1)
      // ]);
    }
    else{
      setGroups([
        ...groups.slice(0, index),
        group,
        ...groups.slice(index + 1)
      ]);
    }
  }

  render() {
    const { groups, optionNames, names } = this.props;

    const groupOpts = optionNames.map((option) => {
      return({value: option, label: names[option]});
    });

    groupOpts.unshift({value: '', label: '(Пусто)'});

    const mappedGroups = groups.map((group, index) => {
      return(
        <div className="input-group" key={index}>
          <Select
            style={{width:'230px'}}
            options={groupOpts}
            simpleValue={true}
            value={group}
            onChange={(e) => this.setGroup(index, e)}
          />{" "}
        </div>
      );
    });

    const addGroup = groups.length < 4 ?
      <div className="input-group">
        <Select
          style={{width:'230px'}}
          options={groupOpts}
          simpleValue={true}
          value={''}
          onChange={(e) => this.setGroup(groups.length, e)}
        />
      </div>
      : [];

    return (
      <div className="form-inline">
        {mappedGroups}
        {addGroup}
      </div>
    );
  }

}

GroupsForm.propTypes = {
  groups: PropTypes.array.isRequired,
  optionNames: PropTypes.array.isRequired,
  names: PropTypes.object.isRequired,
  setGroups: PropTypes.func.isRequired
}

export default GroupsForm;



// WEBPACK FOOTER //
// ./src/components/reports/payments/GroupsForm.js